"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FocusTrapContext", {
    enumerable: true,
    get: function() {
        return FocusTrapContext;
    }
});
const _react = require("react");
const FocusTrapContext = (0, _react.createContext)({
    ref: {
        current: null
    }
});

//# sourceMappingURL=FocusTrapContext.js.map